<template>
	<div style="width: 100%; margin-left: auto; margin-right: auto">
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("subscriptions") }}</h1>
				</div>

				<div class="header_actions">
					<div class="header_actions-container">
						<div v-if="isSuperAdmin">
							<div></div>
							<payments-add :show="add" :school="school" @close="add = false" @add="handleAdd" />
							<option-button
								v-if="isSuperAdmin"
								:show="true"
								:buttons="buttons"
								:error="dateError"
								@clear="handleClear"
								@save="handleRenews(true)"
								@add="add = true"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-loading="loading" style="position: relative">
			<app-total
				:total="pagination.tot"
				:start="pagination.offset"
				:end="pagination.offset + subscriptions.length"
			/>
			<md-table v-model="subscriptions">
				<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
					<md-table-cell :md-label="'id'" width="50">{{ item.id }}</md-table-cell>
					<md-table-cell :md-label="$t('status')" width="100">
						<el-tag
							v-if="
								new Date(item.valid_from).toISOString().slice(0, 10) >
								new Date().toISOString().slice(0, 10)
							"
							type="warning"
							effect="dark"
							>{{ $t("waiting") }}
						</el-tag>
						<el-tag
							v-else-if="
								new Date(item.valid_until).toISOString().slice(0, 10) >
								new Date().toISOString().slice(0, 10)
							"
							type="success"
							effect="dark"
							>{{ $t("active") }}
						</el-tag>
						<el-tag
							v-else-if="
								new Date(item.valid_until).toISOString().slice(0, 10) <
								new Date().toISOString().slice(0, 10)
							"
							type="danger"
							effect="dark"
							>{{ $t("expired") }}
						</el-tag>
					</md-table-cell>
					<md-table-cell :md-label="$t('subscription')" width="200"
						>{{ item.subscription.name }}
					</md-table-cell>
					<md-table-cell :md-label="$t('amount')" width="100"
						>{{ "€ " + item.amount.toFixed(2) }}
					</md-table-cell>
					<md-table-cell :md-label="$t('valid-from')" width="150">
						<el-date-picker
							@focus="focus = true"
							:class="{ 'md-elevation-4': !focus }"
							v-if="renews && renews.id == item.id"
							v-model="valid_from"
							style="width: 150px"
							@change="checkDate"
						/>
						<span v-else>{{ moment(item.valid_from).format("DD/MM/YYYY") }}</span>
					</md-table-cell>
					<md-table-cell :md-label="$t('valid-until')" width="150">
						<el-date-picker
							@focus="focus = true"
							:class="{ 'md-elevation-4': !focus }"
							v-if="renews && renews.id == item.id"
							v-model="valid_until"
							style="width: 150px"
							@change="checkDate"
						/>
						<span v-else>{{ moment(item.valid_until).format("DD/MM/YYYY") }}</span>
					</md-table-cell>
					<md-table-cell width="25" v-if="dateError">
						<el-tooltip
							content="Le date inserite non sono corrette."
							placement="top"
							v-if="renews.id === item.id"
						>
							<md-icon style="color: #e96a6a">warning</md-icon>
						</el-tooltip>
					</md-table-cell>
					<md-table-cell width="75" v-if="isSuperAdmin">
						<el-popover trigger="hover" placement="left">
							<div slot="reference">
								<md-button class="md-icon-button" @click="e => e.stopPropagation()">
									<md-icon>more_vert</md-icon>
								</md-button>
							</div>
							<div>
								<div v-if="isSuperAdmin" class="menu-item" @click="renews = item">
									<i class="el-icon-edit" style="margin-right: 5px" />
									<span>{{ $t("extends") }}</span>
								</div>
							</div>
						</el-popover>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<div v-if="subscriptions.length == 0">
				<p>{{ $t("empty-result") }}</p>
			</div>
		</div>
		<div style="background-color: yellow">
			<app-pagination
				:tot="pagination.tot"
				:size="pagination.size"
				:offset="pagination.offset"
				@fetch="(a, b) => doFetch(a, b)"
			/>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import OptionButton from "@/modules/_common/button/option-button.vue"
import AddButton from "@/modules/_common/button/add-button.vue"
import inputModal from "@/modules/_common/modal/input-modal.vue"
import PaymentsAdd from "@/modules/users/payments/payments-components/payments-add.vue"
import AppPagination from "../../_common/table/app-pagination.vue"
import AppTotal from "../../_common/table/app-total.vue"

export default {
	components: {
		inputModal,
		OptionButton,
		AddButton,
		PaymentsAdd,
		AppPagination,
		AppTotal
	},
	name: "organization-subscriptions",
	props: ["school", "clear"],
	data() {
		return {
			subscriptions: [],
			buttons: ["add"],
			renews: undefined,
			valid_until: undefined,
			valid_from: undefined,
			focus: false,
			add: false,
			loading: false,
			dateError: false,

			pagination: {
				size: 50,
				offset: 0,
				tot: 0
			}
		}
	},
	computed: {
		...mapGetters({
			isSuperAdmin: "user/isSuperAdmin",
			user: "user/user"
		})
	},
	watch: {
		renews: function () {
			if (this.renews == undefined) {
				this.buttons = ["add"]
			} else {
				this.buttons = ["clear", "save"]
				this.valid_until = this.renews.valid_until
				this.valid_from = this.renews.valid_from
			}
		}
	},
	created() {
		this.get()
	},
	methods: {
		moment,
		...mapActions({
			doMutate: "payment/doMutate"
		}),
		checkDate() {
			const start = new Date(this.valid_from)
			const end = new Date(this.valid_until)
			this.dateError = end < start
		},
		handleClear() {
			this.renews = undefined
			this.focus = false
			this.valid_until = undefined
			this.valid_from = undefined
		},
		handleRenews: function (value) {
			if (this.dateError) return
			if (!value) {
				this.handleClear()
				return
			}

			const payload = {
				id: this.renews.id,
				organization_id: this.school.id,
				valid_until: this.valid_until,
				valid_from: this.valid_from
			}

			axios
				.post(process.env.VUE_APP_API_URL + "/api/payments/update", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.$notification(
						res.data ? "success" : "error",
						this.$t("updating-school-subscription"),
						"",
						res.data ? 4500 : 0
					)
					this.subscriptions[this.subscriptions.indexOf(this.renews)].valid_until = this.valid_until
					this.subscriptions[this.subscriptions.indexOf(this.renews)].valid_from = this.valid_from
					this.handleClear()
				})
				.catch(err => {
					if (err.response.status === 400) {
						this.$notification("error", this.$t("anotherone-active"), "", 0)
					}
					if (err.response.status == 409) {
						this.$notification({
							title: this.$t("updating-school-subscription"),
							type: "error",
							duration: 0,
							message: ("i", { style: "color: teal" }, this.$t("conflict-subscription-error"))
						})
					}
					console.error(err)
				})
		},
		handleAdd: function (item) {
			//this.subscriptions.push(item)

			this.add = false
			this.get()
		},

		doFetch: function (page, size) {
			if (size) this.pagination.size = size
			if (page) this.pagination.offset = (page - 1) * this.pagination.size

			this.get()
		},

		get: function () {
			this.loading = true
			var url = "/api/payments"
			if (this.school != undefined && this.isSuperAdmin) url = url + "/" + this.school.id
			const payload = {
				size: this.pagination.size,
				offset: this.pagination.offset
			}
			axios
				.post(process.env.VUE_APP_API_URL + url, payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.subscriptions = res.data.array
					this.pagination.tot = res.data.count
					this.loading = false
				})
				.catch(err => console.error(err))
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-menu";

.el-input__inner {
	background-color: #eeeeee;
}
</style>
